import React from 'react';
import { Badge } from '@appkit4/react-components/badge';
import styles from './DesignSystemBadge.module.scss';

import AppkitIcon from '../../assets/images/Appkit.svg';
import AppkitRebrandIcon from '../../assets/images/AppkitRebrand.svg';
import FluentIcon from '../../assets/images/Fluent.svg';
import MaterialIcon from '../../assets/images/Material.svg';
import NewEraIcon from '../../assets/images/NewEra.svg';

interface DesignSystemBadgeProps {
    designSystem?: string;
    iconName?: string;
    size?: 'sm' | 'md' | 'lg';
    type?: 'primary-outlined' | 'primary' | 'secondary' | 'danger' | 'warning' | 'success';
    showName?: boolean;
}

const DesignSystemBadge: React.FC<DesignSystemBadgeProps> = ({
    designSystem,
    iconName,
    size = 'sm',
    type = 'primary-outlined',
    showName = false,
}) => {
    const iconToSystemMap: Record<string, string> = {
        AppkitIcon: 'Appkit',
        AppkitRebrandIcon: 'AppkitRebrand',
        FluentIcon: 'Fluent',
        MaterialIcon: 'MaterialUI',
        NewEraIcon: 'NewEra',
    };
    const systemToUse = designSystem || (iconName ? (iconToSystemMap[iconName] ?? null) : null);

    if (!systemToUse || (!designSystem && !iconName)) {
        return null;
    }

    const renderBadgeContent = () => {
        const iconMap: Record<string, React.FC> = {
            Appkit: AppkitIcon,
            AppkitRebrand: AppkitRebrandIcon,
            Fluent: FluentIcon,
            MaterialUI: MaterialIcon,
            NewEra: NewEraIcon,
        };
        const labelMap: Record<string, string> = {
            Appkit: 'Appkit',
            AppkitRebrand: 'Rebrand',
            Fluent: 'Fluent',
            MaterialUI: 'MaterialUI',
            NewEra: 'New Era',
        };
        const Icon = systemToUse ? iconMap[systemToUse] : null;
        if (!Icon) return null;

        if (showName) {
            return (
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Icon />
                    {labelMap[systemToUse!]}
                </span>
            );
        }
        return <Icon />;
    };

    const badgeContent = renderBadgeContent();
    if (!badgeContent) {
        return null;
    }

    const badge = <Badge value={badgeContent} size={size} type={type} />;

    return <div className={styles['design-system-badge']}>{badge}</div>;
};

export default DesignSystemBadge;
